<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <template #activator="{ on, attrs }">
      <mf-button v-bind="attrs" outlined :color="error ? 'error' : 'primary'" label="Configurar Opções" v-on:click.native="on.click" />
    </template>
    <mf-card-container title="Configurar Opções" description="Configure as opções para este atributo dinâmico.">
      <template #filters>
        <v-spacer />
        <mf-button icon="add" color="primary" label="Adicionar opção" @click="addOption" />
      </template>
      <div style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
        <v-row v-for="(option, index) in localOptions" :key="index" class="mb-2">
          <v-col cols="5" class="pb-0">
            <v-text-field
              :ref="`option-label-${index}`"
              v-model="option.label"
              label="Label"
              outlined
              dense
              hide-details
              :error-messages="getOptionError(index, 'label')"
            />
          </v-col>
          <v-col cols="5" class="pb-0">
            <v-text-field :value="getOptionValue(option.label)" label="Valor (gerado automaticamente)" outlined dense hide-details disabled />
          </v-col>
          <v-col cols="2" class="d-flex align-center pb-0">
            <mf-button type="icon" icon="delete" color="error" @click="removeOption(index)" />
          </v-col>
        </v-row>
      </div>
      <mf-action-buttons
        :primary-button="{
          text: 'Salvar',
          action: save,
          isVisible: true,
          isDisabled: !isValid || loading,
          isLoading: loading,
        }"
        :cancel-button="{
          text: 'Cancelar',
          action: cancel,
          isVisible: true,
          isDisabled: loading,
        }"
      />
    </mf-card-container>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfigureDynamicAttributeOptions',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      localOptions: [],
    }
  },
  computed: {
    isValid() {
      return this.localOptions.length > 0 && this.localOptions.every((opt) => opt.label && opt.label.trim())
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.localOptions = this.value.length > 0 ? [...this.value] : [{ label: '' }]
      }
    },
    value: {
      handler(newVal) {
        if (!this.dialog) {
          this.localOptions = newVal.length > 0 ? [...newVal] : []
        }
      },
      immediate: true,
    },
  },
  methods: {
    getOptionValue(label) {
      if (!label) return ''
      return label
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9_]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '')
    },
    getOptionError(index, field) {
      const option = this.localOptions[index]
      if (!option || !option[field]) return ''
      if (field === 'label' && !option.label.trim()) {
        return 'Label é obrigatório'
      }
      return ''
    },
    addOption() {
      this.localOptions.push({ label: '' })
      this.$nextTick(() => {
        const emptyIndex = this.localOptions.findIndex((opt) => !opt.label || !opt.label.trim())
        if (emptyIndex !== -1) {
          const ref = this.$refs[`option-label-${emptyIndex}`]
          if (ref && ref[0] && ref[0].$el) {
            const input = ref[0].$el.querySelector('input')
            if (input) {
              input.focus()
            }
          }
        }
      })
    },
    removeOption(index) {
      this.localOptions.splice(index, 1)
    },
    cancel() {
      this.dialog = false
      this.localOptions = this.value.length > 0 ? [...this.value] : []
    },
    save() {
      if (!this.isValid) return
      const options = this.localOptions
        .filter((opt) => opt.label && opt.label.trim())
        .map((opt) => ({
          label: opt.label.trim(),
          value: this.getOptionValue(opt.label.trim()),
        }))
      this.$emit('input', options)
      this.dialog = false
    },
  },
}
</script>
